export default __webpack_public_path__ + "static/media/virginmedia.7298dddd.svg";